import BedtimeIcon from "@mui/icons-material/Bedtime";
import SunnyIcon from "@mui/icons-material/Sunny";
import type { FC } from "react";
import { SHIFT_DAY, SHIFT_NIGHT_FALLBACK } from "../../../../theme/tokens";
import { ShiftType } from "../../../../utils/models";

export const ShiftTypeIcon: FC<{ shiftType: ShiftType }> = ({ shiftType }) => {
	switch (shiftType) {
		case ShiftType.All:
			return (
				<>
					<SunnyIcon sx={{ color: SHIFT_DAY, fontSize: "inherit" }} />
					<BedtimeIcon sx={{ color: SHIFT_NIGHT_FALLBACK, fontSize: "inherit" }} />
				</>
			);
		case ShiftType.Day:
			return <SunnyIcon style={{ color: SHIFT_DAY, fontSize: "inherit" }} />;
		case ShiftType.Night:
			return <BedtimeIcon style={{ color: SHIFT_NIGHT_FALLBACK, fontSize: "inherit" }} />;
		default:
			return <div>?</div>;
	}
};
